const FAQ_ITEMS = [
  {
    q: '番茄漫画上的所有漫画都是免费的吗？',
    a: '是的，番茄漫画平台上的全部漫画内容均免费提供给读者阅读，包括连载中的最新话和已完结的全集漫画。我们坚持免费模式，让每一位漫画爱好者都能无门槛享受阅读乐趣。',
  },
  {
    q: '漫画更新频率是怎样的？韩漫和日漫更新速度有差别吗？',
    a: '热门连载漫画通常在韩国或日本更新后 2-4 小时内完成翻译上线。韩漫、日漫、国漫的更新频率取决于原作更新节奏，我们会尽最大努力保持同步。追漫提醒功能可以帮助你第一时间获知更新。',
  },
  {
    q: '什么是下拉式滚动阅读？和传统翻页有什么区别？',
    a: '下拉式滚动阅读是一种更适合手机阅读的漫画浏览方式，你只需向下滑动屏幕即可连续阅读，无需点击翻页按钮。这种方式让阅读节奏更流畅自然，尤其适合条漫格式的韩漫和国产漫画。',
  },
  {
    q: '如何订阅追漫提醒？',
    a: '在任意漫画详情页点击"订阅追漫"按钮即可。当该漫画有新章节更新时，你会收到推送通知。你可以在个人书架中管理所有已订阅的漫画和提醒设置。',
  },
  {
    q: '支持离线阅读吗？如何缓存漫画？',
    a: '使用番茄漫画 App（iOS/Android）可以缓存漫画章节进行离线阅读。在漫画阅读页面点击缓存按钮，选择需要缓存的章节即可。移动网页版暂不支持离线缓存功能。',
  },
  {
    q: '如何联系漫画作者或进行投稿合作？',
    a: '漫画作者和创作团队欢迎通过我们的官方邮箱 submit@fanqiecomic.com 进行投稿和合作洽谈。商务合作请注明合作意向，我们会在 1-2 个工作日内回复。读者意见反馈请发送至 feedback@fanqiecomic.com。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于追漫、更新和使用体验，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-line"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed pl-6">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}